import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../styles/Header.css";
import logo from "../assets/media/logo.png";
import { company } from "../data/site";

const links = [
	{ to: "/services", label: "Capabilities" },
	{ to: "/#equipment", label: "Equipment" },
	{ to: "/#contact", label: "Contact" },
];

export default function Header() {
	const [open, setOpen] = useState(false);
	const location = useLocation();

	// Close the mobile menu whenever the route or hash changes.
	useEffect(() => setOpen(false), [location.pathname, location.hash]);

	// Close on Escape for keyboard users.
	useEffect(() => {
		if (!open) return;
		const onKey = (e) => e.key === "Escape" && setOpen(false);
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [open]);

	return (
		<header className="site-header">
			<a className="skip-link" href="#main">
				Skip to content
			</a>
			<div className="site-header__inner">
				<Link to="/" className="site-header__brand" aria-label="B & H Machining home">
					<img src={logo} alt="B & H Machining" width="480" height="309" />
				</Link>

				<button
					type="button"
					className="site-header__menu-btn"
					aria-expanded={open}
					aria-controls="site-nav"
					onClick={() => setOpen((v) => !v)}
				>
					{open ? "Close" : "Menu"}
				</button>

				<nav id="site-nav" className={`site-nav${open ? " is-open" : ""}`} aria-label="Main">
					<ul>
						{links.map((l) => (
							<li key={l.to}>
								{l.to.includes("#") ? (
									<Link to={l.to}>{l.label}</Link>
								) : (
									<NavLink to={l.to}>{l.label}</NavLink>
								)}
							</li>
						))}
					</ul>
					<a className="site-nav__phone" href={company.phoneHref}>
						{company.phone}
					</a>
					<Link to="/quote" className="button button--primary">
						Request a quote
					</Link>
				</nav>
			</div>
		</header>
	);
}
